import { Grid } from "@mui/material";

import { ApiDealsRoutesItem } from "@/api/routes";

import RoutesItem from "../RoutesItem";

const RoutesList = (props: {
  data: ApiDealsRoutesItem[];
  onClick: (v: ApiDealsRoutesItem) => void;
  onAlertClick: (v: ApiDealsRoutesItem) => void;
}) => {
  return (
    <div>
      <Grid container spacing={2}>
        {props.data.map((item, index) => {
          return (
            <RoutesItem
              key={index}
              data={props.data[index]}
              onClick={props.onClick}
              onAlertClick={props.onAlertClick}
            />
          );
        })}
      </Grid>
    </div>
  );
};

export default RoutesList;
